import { closeModal, useModals, type ModalEntry } from '../services/Modals'
import ScoreDetailsModal from '../tabs/modals/ScoreDetailsModal'
import LowTraceSentencesModal from '../tabs/modals/LowTraceSentencesModal'

// Single mount point for the service-driven modals. Subscribes to the
// Modals store and renders the matching component for every open
// entry - the same pattern ToastMessages uses for toasts. Components
// that need to surface a popout call `openScoreDetailsModal(...)` /
// `openLowTraceSentencesModal(...)` and don't carry any modal state
// themselves.
export default function ModalHost() {
  const modals = useModals()
  return (
    <>
      {modals.map((m: ModalEntry) => {
        if (m.kind === 'scoreDetails') {
          return (
            <ScoreDetailsModal
              key={m.id}
              open
              onClose={() => closeModal(m.id)}
              question={m.question}
              prevQuestion={m.prevQuestion}
              labelLeft={m.labelLeft}
              labelRight={m.labelRight}
              title={m.title}
            />
          )
        }
        if (m.kind === 'lowTraceSentences') {
          return (
            <LowTraceSentencesModal
              key={m.id}
              open
              onClose={() => closeModal(m.id)}
              structure={m.structure}
              overallSimint={m.simint}
              prevStructure={m.prevStructure}
              prevSimint={m.prevSimint}
              labelLeft={m.labelLeft}
              labelRight={m.labelRight}
              title={m.title}
              threshold={m.threshold}
            />
          )
        }
        return null
      })}
    </>
  )
}
